import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import Auth from '@aws-amplify/auth'
import { NbToastrService } from '@nebular/theme'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { resetState } from '../../app.actions'
import { selectRouteData } from '../../app.selector'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  login = {
    mail: null,
    password: null,
  }

  register = {
    mail: null,
    password: null,
    consent: null,
    confirmationCode: null,
    newsletter: null,
  }

  reset = {
    mail: null,
    code: null,
    new_password: null,
  }

  routeData$: Observable<any>
  resetPasswordStep2: boolean
  registerStep2: boolean


  constructor(
    private toastr: NbToastrService,
    private store: Store,
    private router: Router
  ) { }

  ngOnInit() {
    this.routeData$ = this.store.select(selectRouteData)
  }
  log(a) {
    console.log(a)
  }

  async resetPassword() {
    if (this.resetPasswordStep2) {
      try {
        await Auth.forgotPasswordSubmit(this.reset.mail, this.reset.code, this.reset.new_password)
        this.router.navigate(['']);
        await Auth.signIn(this.reset.mail, this.reset.new_password)
        this.toastr.info('Password reset success', '', { duration: 7000 })
      } catch (error) {
        this.toastr.warning(`error resetting the password`)
      }
    } else {
      try {
        await Auth.forgotPassword(this.reset.mail)
        this.toastr.info('Check your mailbox for the verification code', '', { duration: 7000 })
        this.resetPasswordStep2 = true
      } catch (error) {
        this.toastr.warning(`error resetting the password`)
      }
    }
  }

  async signIn() {
    try {
      this.store.dispatch(resetState())
      await Auth.signIn(this.login.mail, this.login.password)
    } catch (error) {
      this.toastr.warning(error.message)
    }
  }

  async signUp() {
    let signUpResult;
    let error;

    signUpResult = await Auth.signUp({
      username: this.register.mail,
      password: this.register.password,
      attributes: {
        'custom:consent-accepted': this.register.consent ? '1' : '0',
        'custom:newsletter': this.register.newsletter ? '1' : '0',
      },
    }).catch(e => error = e);

    if (error && error.code === 'UsernameExistsException') {
      signUpResult = await Auth.resendSignUp(this.register.mail).catch(e => error = e);
    } else if (error) {
      this.toastr.warning(error.message, '', { duration: 7000 })
      return;
    }

    if (signUpResult) {
      this.toastr.info(
        'Great! Check your mail box for the confirmation mail.',
        '',
        { duration: 7000 },
      )
      this.registerStep2 = true;
    } else {
      this.toastr.warning(error.message, '', { duration: 7000 })
    }
  }

  async confirmSignUp() {
    try {
      await Auth.confirmSignUp(
        this.register.mail,
        this.register.confirmationCode,
      )
      await Auth.signIn(this.register.mail, this.register.password)
      this.toastr.info('You are ready to login.', '', { duration: 7000 })
    } catch (error) {
      this.toastr.warning(error.message, '', { duration: 7000 })
      console.log('error confirming sign up', error)
    }
  }
}
